
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["feather feather-user",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","stroke":"currentColor","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round","class":"feather feather-user"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M20 21v-2a4 4 0 00-4-4H8a4 4 0 00-4 4v2"}}),_c('circle',{attrs:{"cx":"12","cy":"7","r":"4"}})])
          )
        }
      }
    